import {
  RadioButtonIcon,
  CircleIcon,
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
  CircleCheckIcon,
  CancelCircleIcon,
  EighteenPlusIcon,
  HomeIcon,
  MagnifyingGlassIcon,
  AngleDownIcon,
  AlertTriangleIcon,
  ArrowLeftIcon,
  FacebookIcon,
  GoogleIcon,
  CheckmarkIcon,
  CloseIcon,
  PlusIcon,
  TicketIcon,
  EditIcon,
  VoteIcon,
  ArrowRightIcon,
  CalendarIcon,
  MenuIcon,
  NewspaperIcon,
  GearIcon,
  StarIcon,
  LetterIcon,
  BookmarksIcon,
  BellIcon,
  ShareIcon,
  LockIcon,
  CrownIcon,
  CrownFilledIcon,
  LogoutIcon,
  DragIcon,
  Dots2x3Icon,
  ThinPlusIcon,
  ThinMinusIcon,
  CommentIcon,
  UpvoteIcon,
  DownvoteIcon,
  UpvoteFilledIcon,
  DownvoteFilledIcon,
  PollIcon,
  ClockIcon,
  TelegramIcon,
  WhatsAppIcon,
  TwitterIcon,
  ViberIcon,
  CopyIcon,
  PersonCircleOutlineIcon,
  InfoIcon,
  InformationOutlineIcon,
  CaretDownIcon,
  CaretUpIcon,
  AngleLeftIcon,
  AngleRightIcon,
  BackIcon,
  AttachIcon,
  PostIcon,
  PostTipIcon,
  EmojiIcon,
  FavouriteIcon,
  CircleCrossIcon,
  CircleVoidIcon,
  ThreeDotsIcon,
  SpinIcon,
  EventsIcon,
  BrushIcon,
  TrashBinIcon,
  PinIcon,
  AddCircleOutlineIcon,
  FootballIcon,
  ChannelStar,
  EditPencileIcon,
  TennisIcon,
  GolfIcon,
  CyclingIcon,
  ESportsIcon,
  RugbyIcon,
  CricketIcon,
  BasketballIcon,
  BaseballIcon,
  AmericanFootballIcon,
  HockeyIcon,
  VolleyballIcon,
  BrandIcon,
  CirclesIcon,
  WalletIcon,
  TeamIcon,
  EarthOutlineIcon,
  ShareIOSSafariIcon,
  ShareIOSSafariModernIcon,
  HomeScreenIOSSafariIcon,
  HomeScreenIOSSafariModernIcon,
  HandballIcon,
  RugbyLeagueIcon,
  BoxingIcon,
  MMAIcon,
  TableTennisIcon,
  TandC,
  InstagramIcon,
  Delete,
  Warning,
  Upload,
  AddImage,
  AddGif,
  IosInstall,
  IosShareIcon,
  RedirectIcon,
  DownloadIcon,
  DownloadArrow,
  StarLineIcon,
  ShareLineIcon,
  AddUserLineIcon,
  AngleTopIcon,
  AngledownLineIcon,
  GlassesIcon,
  LogoutLineIcon,
  MailIcon,
  SavedTipIcon,
  UserCheckIcon,
  SubscriberListIcon,
  NotificationIcon,
  WorldIcon,
  ShareIconUpdate,
  ShareArrowIcon,
  MatchesVotedIcon,
  TrashBinLineIcon,
  LockLineIcon,
  PlusLineIcon,
  NotificationLineIcon,
  CalendarLineIcon,
  StarLineIconFilled,
  MenuHorizontalIcon,
  TimeDivider,
  InfoCircledIcon,
  UserPlusIcon,
  DownvoteBoldIcon,
  UpvoteBoldIcon,
  ShareLineBoldIcon,
  CommentBoldIcon,
  HomeLineIcon,
  ChannelLineIcon,
  VotingLineIcon,
  VipIcon,
  FreeIcon,
  FreeBrandIcon,
  VipBrandIcon,
  TipWonIcon,
  TipLostIcon,
  MenuLineIcon,
  TipIcon,
  PollLineIcon,
  MarkIcon,
  CloseLineIcon,
  SendIcon,
  AngleDownBoldIcon,
  TotalTipChartIcon,
  WinRateChartIcon,
  UploadArrowIcon,
  ImageUploadBackdrop,
  AddIcon,
  CloseBigIcon,
  DeleteLineIcon,
  EditImageIcon,
  MultipleChannelIcon,
  CircleCheckWithBorder,
  SearchIcon,
  PaymentHeader,
  DollarIcon,
  PercentageIcon,
  CommentLineIcon,
  DividerIcon,
  AngleUpIcon,
  AngleDownThinIcon,
  FootballHeader,
  MagicLinkIcon,
  WaterMarkIcon,
  ServiceIcon,
  MagicLinkRingIcon,
  DangerIcon,
  ArrowFullIcon,
  CloseMenuIcon,
  HomeRefreshedIcon,
  ChannelIcon,
  VoteRefreshedIcon,
  HambugerIcon,
  MessageIcon,
  ScoreLineIcon,
  SubscriptionIcon,
  ChannelInviteIcon,
  SupportIcon,
  LiveChatIcon,
  SendMessageIcon,
  EnvelopeIcon,
  TicketStarIcon,
  WriteIcon,
  TaskSquareIcon,
  CaretRightIcon,
  BookIcon,
  QuestionSquareIcon,
  DeviceMessageIcon,
  ProfileIcon,
  ShareFIlledIcon,
  CrossedLockIcon,
  FilterIcon,
  FirstPlace,
  ThirdPlace,
  SecondPlace,
  WinRate,
  NewIcon,
  FeaturedIcon,
  HotIcon,
  MostProfitIcon,
  TopFootballIcon,
  TopTennisIcon,
  TrendIcon,
  LeaderboardIcon,
  CompetitionsFootbalIcon,
  FirstCompetitionPlace,
  SecondCompetitionPlace,
  ThirdCompetitionPlace,
  InfoOutlineIcon,
  StatisticIcon,
  VoteBettingFadedIcon,
  SocialMediaKitIcon,
  TelegramKitIcon,
  ElipseArrowIcon,
  LinkIcon,
  StarsIcon,
  AiIcon,
  AddImageIcon,
  PlayIcon,
  PauseIcon,
  StopIcon,
  StreamIcon,
  LiveStreamIcon,
  HeadphonesIcon,
  AppInviteIcon,
  MicroPhoneMutedIcon,
  FrameIcon,
  ChartIcon,
  TelegramSocialIcon,
  XIcon,
  InstagramSocialIcon,
  LinkedInIcon,
  InternetIcon,
  RingsIcon,
  BonusEmptyIcon,
  BonusIcon,
  RewardCashBonusIcon,
  RewardFreeTicketIcon,
  RewardFreeBetIcon,
  RewardFirstDepositIcon,
  RewardMerchIcon,
  RewardFreeSpinIcon,
  RewardFreeSubscriptionsIcon,
  RewardOtherIcon,
  FolderSettingsIcon,
  MediaImageIcon,
  VoiceIcon,
  GifFormatIcon,
  VideoCameraIcon,
  MicrophoneIcon,
  RecordIcon,
  SubscriptionPlanIcon,
  TelegramBotIcon,
  LoadingIcon,
  ChangeRolesIcon,
} from './svg'
import CompetitionIcon from './svg/CompetitionIcon'
import DocumentIcon from './svg/DocumentIcon'
import ExternalLink from './svg/ExternalLink'

export enum IconSize {
  xsmall = 16,
  midSmall = 20,
  small = 24,
  medium = 28,
  midLarge = 30,
  large = 32,
  xLarge = 48,
}

// duplicates colors from "main.css"
export enum IconColor {
  fontPrimary = '#1E2023',
  fontPrimaryDarker = '#1B443C',
  fontBrandDark = '#1BAA90',
  fontBrandDarkNew = '#1B504A',
  fontBlack = '#212121',
  fontBlackNew = '#2B2D30',
  brand = 'var(--violet-900)',
  dark = '#000000',
  viloet300 = 'var(--violet-300)',
  menuHighlightIcon = 'var(--menu-highlight-icon)',
  subMenuHighlight = 'var(--sub-menu-highlight)',
  viloet400 = 'var(--violet-400)',
  zinc500 = 'var(--zinc-500)',
  zinc400 = 'var(--zinc-400)',
  zinc600 = 'var(--zinc-600)',
  zinc400Opacity20 = 'rgba(161, 161, 170, 0.1)',
  colotSenary = 'var(--zinc-50)',
  textPrimary = 'var(--text-primary)',
  textNonary = 'var(--text-nonary)',
  ratingStar = 'var(--rating-star)',
  leagueIcon = 'var(--league-icon)',
  voteInactive = 'var(--icon-vote-inactive)',
  commentInactive = 'var(--icon-comment)',
  shareInactive = 'var(--icon-share)',
  starInactive = 'var(--icon-star)',
  violete600 = 'var(--violet-600)',
  brandDark = '#1BAB92',
  warning = '#FA7676',
  success = '#27C27D',
  grayLight = '#F4F5F8',
  grayDark = '#A4A4A4',
  mediumGray = '#202020',
  grayLightest = '#828DA1',
  grayDarkNew = '#5D656D',
  grayDarker = '#666666',
  grayLighter = '#A8AEB6',
  grayLightestNew = '#92979F',
  blueNew= '#5984D9',
  grayExtraLightestNew = '#B4BCC8',
  grayDarkest = '#4D4D4D',
  grayNavigation = '#92949C',
  grayC = '#CCCCCC',
  chosenDate = '#FBCB24',
  facebookBlue = '#4267B2',
  white = '#FFFFFF',
  lightGrayNew = '#FAFAFA',
  tertiary = '#4854E0',
  quaternaryGolden = '#FFD029',
  buttonColor = '#211B50',
  iconPurple = '#5547C0',
  blue = '#476BDE',
  lightGreen = '#37FFB9',
  grayGreen= '#A7CBD8',
  grayInactive = '#212121',
  grayStroke = '#A3A3A3',
  grayStrokeNew = '#ACB7C1',
  grayDeep = '#3C3C3C',
  menuColor = '#0A9081',
  buttonGreen = '#48C0AE',
  lime400 = '#A3E635',
  lime600 = '#65A30D',
  red600 = '#DC2626',
  void = '#FF9000',
  red = '#FA7676',
  redSoft = '#FF6565',
  black = '#2B2D35',
  lightDark = '#292D32',
  darkestGray = '#555A76',
  midGray = '#2E3F55',
  lightGray = '#C9D2DE',
  gray = '#88919E',
  midGreen = '#48C0AE',
  yellow = '#EAB808',
  tagBlue = '#60A5FA',
  tagYellow = '#FACC15',
  tagPink = '#F0ABFC',
  tagGreen = '#84CC16',
  tagCyan = '#22D3EE'
}

export interface IconProps {
  size?: IconSize;
  height?: number;
  width?: number;
  type: IconTypes;
  color?: IconColor;
}

export enum IconTypes {
  streamIcon = 'STREAM_ICON',
  liveStreamIcon = 'LIVE_STREAM_ICON',
  ticketStar = 'TICKET_STAR',
  spiralIcon = 'SPIRAL',
  aiIcon = 'AI_ICON',
  ringsIcon = 'RINGS_ICON',
  starsIcon = 'STARS_ICON',
  channelStar = 'CHANNEL_STAR',
  firstCompetitionPlace = 'FIRST_COMPETITION_PLACE',
  secondCompetitionPlace = 'SECOND_COMPETITION_PLACE',
  thirdCompetitionPlace = 'THIRD_COMPETITION_PLACE',
  new = 'NEW',
  featured = 'FEATURED',
  competitionsFootball = 'COMPETITIONS_FOOTBALL',
  hot = 'HOT',
  mostProfit = 'MOST_PROFIT',
  topFootball = 'TOP_FOOTBALLL',
  TopTennis = 'TOP_TENNIS',
  trend = 'TREND',
  winRate = 'WIN_RATE',
  leaderboard = 'LEADERBOARD',
  write = 'WRITE',
  firstPlace = 'FIRST_PLACE',
  secondPlace = 'SECOND_PLACE',
  thirdPlace = 'THIRD_PLACE',
  arrowFull = 'ARROW_FULL',
  taskSquare = 'TASK_SQUARE',
  redirect = 'REDIRECT',
  download = 'DOWNLOAD',
  instagram = 'INSTAGRAM',
  radioButton = 'RADIO_BUTTON',
  circle = 'CIRCLE',
  checkboxChecked = 'CHECKBOX_CHECKED',
  checkboxUnchecked = 'CHECKBOX_UNCHECKED',
  circleCheck = 'CIRCLE_CHECK',
  home = 'HOME',
  magnifyingGlass = 'MAGNIFYING_GLASS',
  angleDown = 'ANGLE_DOWN',
  alertTriangle = 'ALERT_TRIANGLE',
  arrowLeft = 'ARROW_LEFT',
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
  checkmark = 'CHECKMARK',
  close = 'CLOSE',
  plus = 'PLUS',
  ticket = 'TICKET',
  edit = 'EDIT',
  vote = 'VOTE',
  arrowRight = 'ARROW_RIGHT',
  calendar = 'CALENDAR',
  menu = 'MENU',
  newspaper = 'NEWSPAPER',
  gear = 'GEAR',
  star = 'STAR',
  letter = 'LETTER',
  bookmarks = 'BOOKMARKS',
  bell = 'BELL',
  share = 'SHARE',
  elipseArrow = 'ELIPSE_ARROW',
  lock = 'LOCK',
  crown = 'CROWN',
  crownFilled = 'CROWN_FILLED',
  logout = 'LOGOUT',
  drag = 'DRAG',
  dots2x3 = 'DOTS_2X3',
  thinPlus = 'THIN_PLUS',
  thinMinus = 'THIN_MINUS',
  comments = 'COMMENTS',
  upvote = 'UPVOTE',
  externalLink = 'EXTERNAL_LINK',
  downvote = 'DOWNVOTE',
  upvoteFilled = 'UPVOTE_FILLED',
  downvoteFilled = 'DOWNVOTE_FILLED',
  poll = 'POLL',
  clock = 'CLOCK',
  telegram = 'TELEGRAM',
  whatsApp = 'WHATS_APP',
  twitter = 'TWITTER',
  viber = 'VIBER',
  copy = 'COPY',
  personCircle = 'PERSON_CIRCLE',
  info = 'INFO',
  informationOutline = 'INFORMATION_OUTLINE',
  caretDown = 'CARET_DOWN',
  caretRight = 'CARET_RIGHT',
  bookIcon = 'BOOK',
  questionSquare = 'QUESTION_SQUARE',
  deviceMessage = 'DEVICE_MESSAGE',
  infoOutline = 'INFO_OUTLINE',
  caretUp = 'CARET_UP',
  angleLeft = 'ANGLE_LEFT',
  angleRight = 'ANGLE_RIGHT',
  back = 'BACK',
  attach = 'ATTACH',
  post = 'POST',
  competition = 'COMPETITION',
  postTip = 'POST_TIP',
  emoji = 'EMOJI',
  favourite = 'FAVOURITE',
  circleCross = 'CIRCLE_CROSS',
  circleVoid = 'CIRCLE_VOID',
  threeDots = 'THREE_DOTS',
  spin = 'SPIN',
  loading = 'LOADING',
  events = 'EVENTS',
  brush = 'BRUSH',
  trashBin = 'TRASH_BIN',
  pin = 'PIN',
  addCircleOutline = 'ADD_CIRCLE_OUTLINE',
  football = 'FOOTBALL',
  tennis = 'TENNIS',
  golf = 'GOLF',
  cycling = 'CYCLING',
  eSports = 'E_SPORTS',
  rugby = 'RUGBY',
  cricket = 'CRICKET',
  basketball = 'BASKETBALL',
  baseball = 'BASEBALL',
  americanFootball = 'AMERICAN_FOOTBALL',
  hockey = 'HOCKEY',
  volleyball = 'VOLLEYBALL',
  handball = 'HANDBALL',
  rugbyLeague = 'RUGBY_LEAGUE',
  boxing = 'BOXING',
  mma = 'MMA',
  tableTennis = 'TABLE_TENNIS',
  brand = 'BRAND',
  circles = 'CIRCLES',
  wallet = 'WALLET',
  team = 'TEAM',
  tAndC = 'TANDC',
  profile = 'PROFILE',
  earthOutline = 'EARTH_OUTLINE',
  shareIOSSafari = 'SHARE_IOS_SAFARI',
  shareIOSSafariModern = 'SHARE_IOS_SAFARI_MODERN',
  homeScreenIOSSafari = 'HOME_SCREEN_IOS_SAFARI',
  homeScreenIOSSafariModern = 'HOME_SCREEN_IOS_SAFARI_MODERN',
  delete = 'DELETE',
  warning = 'WARNING',
  upload = 'UPLOAD',
  addImage = 'ADDIMAGE',
  addGif = 'ADDGIF',
  IosInstall = 'IOSINSTALL',
  IosShare = 'IOSSHARE',
  DownloadArrow = 'DOWNLOADARROW',
  starLineIcon = 'STARLINEICON',
  shareLineIcon = 'SHARELINEICON',
  shareFilledIcon = 'SHAREFILLEDICON',
  addUserLineIcon = 'ADDUSERLINEICON',
  changeRoles = 'CHANGE_ROLES',
  angleTopIcon = 'ANGLETOPICON',
  angledownLineIcon = 'ANGLEDOWNLINEICON',
  glassesIcon = 'GLASSESICON',
  logoutLineIcon = 'LOGOUTLINEICON',
  mailIcon = 'MAILICON',
  savedTipIcon = 'SAVEDTIPICON',
  userCheckIcon = 'USERCHECKICON',
  subscriberListIcon = 'SUBSCRIBERLISTICON',
  notificationIcon = 'NOTIFICATIONICON',
  worldIcon = 'WORLDICON',
  shareIconUpdate = 'SHAREICONUPDATE',
  shareArrowIcon = 'SHARE_ARROW_ICON',
  channelInvite = 'CHANNELINVITE',
  matchesVotedIcon = 'MATCHESVOTEDICON',
  trashBinLineIcon = 'TRASHBINLINEICON',
  lockLineIcon = 'LOCKLINEICON',
  linkIcon = 'LINKICON',
  plusLineIcon = 'PLUSLINEICON',
  notificationLineIcon = 'NOTIFICATONLINEICON',
  calendarLineIcon = 'CALENDARLINEICON',
  starLineIconFilled = 'STARLINEICONFILLED',
  menuHorizontalIcon = 'MENUHORIZONTALICON',
  timeDivider = 'TIMEDIVIDER',
  infoCircledIcon = 'INFOCIRCLEDICON',
  userPlusIcon = 'USERPLUSICON',
  downvoteBoldIcon = 'DOWNVOTEBOLDICON',
  upvoteBoldIcon = 'UPVOTEBOLDICON',
  shareLineBoldIcon = 'SHARELINEBOLDICON',
  commentBoldIcon = 'COMMENTBOLDICON',
  homeLineIcon = 'HOMELINEICON',
  channelLineIcon = 'CHANNELLINEICON',
  votingLineIcon = 'VOTINGLINEICON',
  vipIcon = 'VIPICON',
  freeIcon = 'FREEICON',
  freeBrandIcon = 'FREEBRANDICON',
  vipBrandIcon = 'VIPBRANDICON',
  tipWonIcon = 'TIPWONICON',
  tipLostIcon = 'TIPLOSTICON',
  menuLineIcon = 'MENULINEICON',
  tipIcon = 'TIPICON',
  pollLineIcon = 'POLLLINEICON',
  markIcon = 'MARKICON',
  closeLineIcon = 'CLOSELINEICON',
  crossedLockIcon = 'CROSSEDLOCKICON',
  sendIcon = 'SENDICON',
  statistics = 'STATISTICS',
  angleDownBoldIcon = 'ANGLEDOWNBOLDICON',
  totalTipChartIcon = 'TOTALTIPCHARTICON',
  winRateChartIcon = 'WINRATECHARTICON',
  uploadArrowIcon = 'UPLOADARROWICON',
  imageUploadBackdrop = 'IMAGEUPLOADBACKDROP',
  addIcon = 'ADDICON',
  closeBigIcon = 'CLOSEBIGICON',
  deleteLineIcon = 'DELETELINEICON',
  editImageIcon = 'EDITIMAGEICON',
  multipleChannelIcon = 'MULTIPLECHANNELICON',
  circleCheckWithBorder = 'CIRCLECHECKWITHBORDER',
  searchIcon = 'SEARCHICON',
  paymentHeader = 'PAYMENTHEADER',
  dollarIcon = 'DOLLARICON',
  percentageIcon = 'PERCENTAGEICON',
  commentLineIcon = 'COMMENTLINEICON',
  dividerIcon = 'DIVIDERICON',
  angleUpIcon = 'ANGLEUPICON',
  angleDownThinIcon = 'ANGLEDOWNTHINICON',
  footballHeader = 'FOOTBALLHEADER',
  magicLinkIcon = 'MAGICLINKICON',
  waterMarkIcon = 'WATERMARKICON',
  ServiceIcon = 'SERVICEICON',
  magicLinkRingIcon = 'MAGICLINKLRINGICON',
  dangerIcon = 'DANGERICON',
  closeMenuIcon = 'CLOSEMENUICON',
  homeRefreshedIcon = 'HOMEREFRESHEDICON',
  channelIcon = 'CHANNELICON',
  voteRefreshedIcon = 'VOTEREFRESHEDICON',
  hambugerIcon = 'HAMBUGERICON',
  messageIcon = 'MESSAGEICON',
  filterIcon = 'FILTERICON',
  scoreLineIcon = 'SCORELINEICON',
  subscriptionIcon = 'SUBSCRIPTIONICON',
  telegramBotIcon = 'TELEGRAM_BOT',
  supportIcon = 'SUPPORTICON',
  liveChatIcon = 'LIVECHATICON',
  sendMessageIcon = 'SENDMESSAGEICON',
  envelopeIcon = 'ENVELOPEICON',
  votebettingFaded = 'VOTEBETTING_FADED',
  socialMediaKit = 'SOCIAL_MEDIA_KIT',
  telegramMediaKit = 'TELEGRAM_MEDIA_KIT',
  editPencileIcon = 'EDITPENCILICON',
  addImageIcon = 'ADDIMAGEICON',
  playIcon = 'PLAYICON',
  pauseIcon = 'PAUSEICON',
  stopIcon = 'STOPICON',
  headphones = 'HEADPHONES',
  documentIcon = 'DOCUMENTICON',
  appInvite = 'APPINVITE',
  microPhoneMuted = 'MICROPHONE_MUTED',
  frameIcon = 'FRAMEICON',
  chartIcon = 'CHARTICON',
  telegramSocial = 'TELEGRAMSOCIAL',
  xIcon = 'XICON',
  instagramSocial = 'INSTAGRAMSOCIAL',
  linkedinSocial = 'LINKEDINSOCIAL',
  internetIcon = 'INTERNETICON',
  bonusEmptyIcon = 'BONUSEMPTYICON',
  bonusIcon = 'BONUSICON',
  rewardCashBonusIcon = 'REWARD_CASH_BONUS_ICON',
  rewardFreeTicketIcon = 'REWARD_FREE_TICKET_ICON',
  rewardFreeBetIcon = 'REWARD_FREE_BET_ICON',
  rewardFirstDepositIcon = 'REWARD_FIRST_DEPOSIT_ICON',
  rewardMerchIcon = 'REWARD_MERCH_ICON',
  rewardFreeSpinIcon = 'REWARD_FREE_SPIN_ICON',
  rewardFreeSubscriptionsIcon = 'REWARD_FREE_SUBSCRIPTIONS_ICON',
  rewardOtherIcon = 'REWARD_OTHER_ICON',
  folderSettingsIcon = 'FOLDERSETTINGSICON',
  mediaImageIcon = 'MEDIAIMAGEICON',
  voiceIcon = 'VOICEICON',
  gifFormatIcon = 'GIFFORMATICON',
  videoCameraIcon = 'VIDEOCAMERAICON',
  microphoneIcon = 'MICROPHONEICON',
  recordIcon = 'RECORDICON',
  subscriptionPlanIcon = 'SUBSCRIPTIONPLANICON',
  cancelCircleIcon = 'CANCELCIRCLEICON',
  eighteenPlusIcon = 'EIGHTEENPLUSICON',
 }

export const SvgIcons = {
  [IconTypes.loading]: LoadingIcon,
  [IconTypes.changeRoles]: ChangeRolesIcon,
  [IconTypes.streamIcon]: StreamIcon,
  [IconTypes.liveStreamIcon]: LiveStreamIcon,
  [IconTypes.leaderboard]: LeaderboardIcon,
  [IconTypes.starsIcon]: StarsIcon,
  [IconTypes.channelStar]: ChannelStar,
  [IconTypes.editPencileIcon]: EditPencileIcon,
  [IconTypes.firstCompetitionPlace]: FirstCompetitionPlace,
  [IconTypes.secondCompetitionPlace]: SecondCompetitionPlace,
  [IconTypes.thirdCompetitionPlace]: ThirdCompetitionPlace,
  [IconTypes.playIcon]: PlayIcon,
  [IconTypes.pauseIcon]: PauseIcon,
  [IconTypes.stopIcon]: StopIcon,
  [IconTypes.competitionsFootball]: CompetitionsFootbalIcon,
  [IconTypes.arrowFull]: ArrowFullIcon,
  [IconTypes.winRate]: WinRate,
  [IconTypes.aiIcon]: AiIcon,
  [IconTypes.votebettingFaded]: VoteBettingFadedIcon,
  [IconTypes.new]: NewIcon,
  [IconTypes.featured]: FeaturedIcon,
  [IconTypes.hot]: HotIcon,
  [IconTypes.externalLink]: ExternalLink,
  [IconTypes.mostProfit]: MostProfitIcon,
  [IconTypes.topFootball]: TopFootballIcon,
  [IconTypes.TopTennis]: TopTennisIcon,
  [IconTypes.trend]: TrendIcon,
  [IconTypes.radioButton]: RadioButtonIcon,
  [IconTypes.ticketStar]: TicketStarIcon,
  [IconTypes.write]: WriteIcon,
  [IconTypes.filterIcon]: FilterIcon,
  [IconTypes.taskSquare]: TaskSquareIcon,
  [IconTypes.redirect]: RedirectIcon,
  [IconTypes.download]: DownloadIcon,
  [IconTypes.firstPlace]: FirstPlace,
  [IconTypes.secondPlace]: SecondPlace,
  [IconTypes.thirdPlace]: ThirdPlace,
  [IconTypes.circle]: CircleIcon,
  [IconTypes.profile]: ProfileIcon,
  [IconTypes.checkboxChecked]: CheckboxCheckedIcon,
  [IconTypes.checkboxUnchecked]: CheckboxUncheckedIcon,
  [IconTypes.circleCheck]: CircleCheckIcon,
  [IconTypes.cancelCircleIcon]: CancelCircleIcon,
  [IconTypes.eighteenPlusIcon]: EighteenPlusIcon,
  [IconTypes.home]: HomeIcon,
  [IconTypes.linkIcon]: LinkIcon,
  [IconTypes.magnifyingGlass]: MagnifyingGlassIcon,
  [IconTypes.angleDown]: AngleDownIcon,
  [IconTypes.alertTriangle]: AlertTriangleIcon,
  [IconTypes.arrowLeft]: ArrowLeftIcon,
  [IconTypes.facebook]: FacebookIcon,
  [IconTypes.google]: GoogleIcon,
  [IconTypes.crossedLockIcon]: CrossedLockIcon,
  [IconTypes.checkmark]: CheckmarkIcon,
  [IconTypes.close]: CloseIcon,
  [IconTypes.elipseArrow]: ElipseArrowIcon,
  [IconTypes.plus]: PlusIcon,
  [IconTypes.ticket]: TicketIcon,
  [IconTypes.edit]: EditIcon,
  [IconTypes.vote]: VoteIcon,
  [IconTypes.arrowRight]: ArrowRightIcon,
  [IconTypes.socialMediaKit]: SocialMediaKitIcon,
  [IconTypes.telegramMediaKit]: TelegramKitIcon,
  [IconTypes.calendar]: CalendarIcon,
  [IconTypes.menu]: MenuIcon,
  [IconTypes.newspaper]: NewspaperIcon,
  [IconTypes.gear]: GearIcon,
  [IconTypes.star]: StarIcon,
  [IconTypes.ringsIcon]: RingsIcon,
  [IconTypes.letter]: LetterIcon,
  [IconTypes.bookmarks]: BookmarksIcon,
  [IconTypes.frameIcon]: FrameIcon,
  [IconTypes.bell]: BellIcon,
  [IconTypes.share]: ShareIcon,
  [IconTypes.lock]: LockIcon,
  [IconTypes.crown]: CrownIcon,
  [IconTypes.crownFilled]: CrownFilledIcon,
  [IconTypes.logout]: LogoutIcon,
  [IconTypes.drag]: DragIcon,
  [IconTypes.dots2x3]: Dots2x3Icon,
  [IconTypes.thinPlus]: ThinPlusIcon,
  [IconTypes.thinMinus]: ThinMinusIcon,
  [IconTypes.comments]: CommentIcon,
  [IconTypes.upvote]: UpvoteIcon,
  [IconTypes.shareFilledIcon]: ShareFIlledIcon,
  [IconTypes.downvote]: DownvoteIcon,
  [IconTypes.upvoteFilled]: UpvoteFilledIcon,
  [IconTypes.downvoteFilled]: DownvoteFilledIcon,
  [IconTypes.poll]: PollIcon,
  [IconTypes.clock]: ClockIcon,
  [IconTypes.telegram]: TelegramIcon,
  [IconTypes.whatsApp]: WhatsAppIcon,
  [IconTypes.twitter]: TwitterIcon,
  [IconTypes.viber]: ViberIcon,
  [IconTypes.copy]: CopyIcon,
  [IconTypes.personCircle]: PersonCircleOutlineIcon,
  [IconTypes.info]: InfoIcon,
  [IconTypes.informationOutline]: InformationOutlineIcon,
  [IconTypes.caretDown]: CaretDownIcon,
  [IconTypes.caretRight]: CaretRightIcon,
  [IconTypes.bookIcon]: BookIcon,
  [IconTypes.questionSquare]: QuestionSquareIcon,
  [IconTypes.deviceMessage]: DeviceMessageIcon,
  [IconTypes.caretUp]: CaretUpIcon,
  [IconTypes.infoOutline]: InfoOutlineIcon,
  [IconTypes.angleLeft]: AngleLeftIcon,
  [IconTypes.angleRight]: AngleRightIcon,
  [IconTypes.back]: BackIcon,
  [IconTypes.attach]: AttachIcon,
  [IconTypes.post]: PostIcon,
  [IconTypes.competition]: CompetitionIcon,
  [IconTypes.postTip]: PostTipIcon,
  [IconTypes.statistics]: StatisticIcon,
  [IconTypes.emoji]: EmojiIcon,
  [IconTypes.favourite]: FavouriteIcon,
  [IconTypes.circleCross]: CircleCrossIcon,
  [IconTypes.circleVoid]: CircleVoidIcon,
  [IconTypes.threeDots]: ThreeDotsIcon,
  [IconTypes.spin]: SpinIcon,
  [IconTypes.events]: EventsIcon,
  [IconTypes.brush]: BrushIcon,
  [IconTypes.trashBin]: TrashBinIcon,
  [IconTypes.pin]: PinIcon,
  [IconTypes.addCircleOutline]: AddCircleOutlineIcon,
  [IconTypes.football]: FootballIcon,
  [IconTypes.microPhoneMuted]: MicroPhoneMutedIcon,
  [IconTypes.appInvite]: AppInviteIcon,
  [IconTypes.tennis]: TennisIcon,
  [IconTypes.golf]: GolfIcon,
  [IconTypes.cycling]: CyclingIcon,
  [IconTypes.eSports]: ESportsIcon,
  [IconTypes.rugby]: RugbyIcon,
  [IconTypes.cricket]: CricketIcon,
  [IconTypes.basketball]: BasketballIcon,
  [IconTypes.baseball]: BaseballIcon,
  [IconTypes.americanFootball]: AmericanFootballIcon,
  [IconTypes.hockey]: HockeyIcon,
  [IconTypes.volleyball]: VolleyballIcon,
  [IconTypes.handball]: HandballIcon,
  [IconTypes.rugbyLeague]: RugbyLeagueIcon,
  [IconTypes.boxing]: BoxingIcon,
  [IconTypes.mma]: MMAIcon,
  [IconTypes.tableTennis]: TableTennisIcon,
  [IconTypes.brand]: BrandIcon,
  [IconTypes.circles]: CirclesIcon,
  [IconTypes.wallet]: WalletIcon,
  [IconTypes.team]: TeamIcon,
  [IconTypes.earthOutline]: EarthOutlineIcon,
  [IconTypes.addImageIcon]: AddImageIcon,
  [IconTypes.documentIcon]: DocumentIcon,
  [IconTypes.shareIOSSafari]: ShareIOSSafariIcon,
  [IconTypes.shareIOSSafariModern]: ShareIOSSafariModernIcon,
  [IconTypes.homeScreenIOSSafari]: HomeScreenIOSSafariIcon,
  [IconTypes.homeScreenIOSSafariModern]: HomeScreenIOSSafariModernIcon,
  [IconTypes.tAndC]: TandC,
  [IconTypes.instagram]: InstagramIcon,
  [IconTypes.delete]: Delete,
  [IconTypes.warning]: Warning,
  [IconTypes.upload]: Upload,
  [IconTypes.addImage]: AddImage,
  [IconTypes.addGif]: AddGif,
  [IconTypes.IosShare]: IosShareIcon,
  [IconTypes.IosInstall]: IosInstall,
  [IconTypes.DownloadArrow]: DownloadArrow,
  [IconTypes.starLineIcon]: StarLineIcon,
  [IconTypes.shareLineIcon]: ShareLineIcon,
  [IconTypes.addUserLineIcon]: AddUserLineIcon,
  [IconTypes.angleTopIcon]: AngleTopIcon,
  [IconTypes.angledownLineIcon]: AngledownLineIcon,
  [IconTypes.glassesIcon]: GlassesIcon,
  [IconTypes.logoutLineIcon]: LogoutLineIcon,
  [IconTypes.mailIcon]: MailIcon,
  [IconTypes.savedTipIcon]: SavedTipIcon,
  [IconTypes.userCheckIcon]: UserCheckIcon,
  [IconTypes.subscriberListIcon]: SubscriberListIcon,
  [IconTypes.subscriptionIcon]: SubscriptionIcon,
  [IconTypes.telegramBotIcon]: TelegramBotIcon,
  [IconTypes.notificationIcon]: NotificationIcon,
  [IconTypes.worldIcon]: WorldIcon,
  [IconTypes.shareIconUpdate]: ShareIconUpdate,
  [IconTypes.shareArrowIcon]: ShareArrowIcon,
  [IconTypes.matchesVotedIcon]: MatchesVotedIcon,
  [IconTypes.trashBinLineIcon]: TrashBinLineIcon,
  [IconTypes.lockLineIcon]: LockLineIcon,
  [IconTypes.plusLineIcon]: PlusLineIcon,
  [IconTypes.notificationLineIcon]: NotificationLineIcon,
  [IconTypes.calendarLineIcon]: CalendarLineIcon,
  [IconTypes.starLineIconFilled]: StarLineIconFilled,
  [IconTypes.menuHorizontalIcon]: MenuHorizontalIcon,
  [IconTypes.timeDivider]: TimeDivider,
  [IconTypes.infoCircledIcon]: InfoCircledIcon,
  [IconTypes.userPlusIcon]: UserPlusIcon,
  [IconTypes.downvoteBoldIcon]: DownvoteBoldIcon,
  [IconTypes.upvoteBoldIcon]: UpvoteBoldIcon,
  [IconTypes.shareLineBoldIcon]: ShareLineBoldIcon,
  [IconTypes.commentBoldIcon]: CommentBoldIcon,
  [IconTypes.homeLineIcon]: HomeLineIcon,
  [IconTypes.channelLineIcon]: ChannelLineIcon,
  [IconTypes.votingLineIcon]: VotingLineIcon,
  [IconTypes.vipIcon]: VipIcon,
  [IconTypes.freeIcon]: FreeIcon,
  [IconTypes.freeBrandIcon]: FreeBrandIcon,
  [IconTypes.vipBrandIcon]: VipBrandIcon,
  [IconTypes.tipWonIcon]: TipWonIcon,
  [IconTypes.tipLostIcon]: TipLostIcon,
  [IconTypes.menuLineIcon]: MenuLineIcon,
  [IconTypes.tipIcon]: TipIcon,
  [IconTypes.pollLineIcon]: PollLineIcon,
  [IconTypes.markIcon]: MarkIcon,
  [IconTypes.closeLineIcon]: CloseLineIcon,
  [IconTypes.sendIcon]: SendIcon,
  [IconTypes.angleDownBoldIcon]: AngleDownBoldIcon,
  [IconTypes.totalTipChartIcon]: TotalTipChartIcon,
  [IconTypes.winRateChartIcon]: WinRateChartIcon,
  [IconTypes.uploadArrowIcon]: UploadArrowIcon,
  [IconTypes.imageUploadBackdrop]: ImageUploadBackdrop,
  [IconTypes.addIcon]: AddIcon,
  [IconTypes.closeBigIcon]: CloseBigIcon,
  [IconTypes.deleteLineIcon]: DeleteLineIcon,
  [IconTypes.editImageIcon]: EditImageIcon,
  [IconTypes.multipleChannelIcon]: MultipleChannelIcon,
  [IconTypes.circleCheckWithBorder]: CircleCheckWithBorder,
  [IconTypes.searchIcon]: SearchIcon,
  [IconTypes.paymentHeader]: PaymentHeader,
  [IconTypes.dollarIcon]: DollarIcon,
  [IconTypes.percentageIcon]: PercentageIcon,
  [IconTypes.commentLineIcon]: CommentLineIcon,
  [IconTypes.dividerIcon]: DividerIcon,
  [IconTypes.angleUpIcon]: AngleUpIcon,
  [IconTypes.angleDownThinIcon]: AngleDownThinIcon,
  [IconTypes.footballHeader]: FootballHeader,
  [IconTypes.magicLinkIcon]: MagicLinkIcon,
  [IconTypes.waterMarkIcon]: WaterMarkIcon,
  [IconTypes.ServiceIcon]: ServiceIcon,
  [IconTypes.magicLinkRingIcon]: MagicLinkRingIcon,
  [IconTypes.dangerIcon]: DangerIcon,
  [IconTypes.closeMenuIcon]: CloseMenuIcon,
  [IconTypes.homeRefreshedIcon]: HomeRefreshedIcon,
  [IconTypes.channelIcon]: ChannelIcon,
  [IconTypes.voteRefreshedIcon]: VoteRefreshedIcon,
  [IconTypes.hambugerIcon]: HambugerIcon,
  [IconTypes.messageIcon]: MessageIcon,
  [IconTypes.scoreLineIcon]: ScoreLineIcon,
  [IconTypes.channelInvite]: ChannelInviteIcon,
  [IconTypes.supportIcon]: SupportIcon,
  [IconTypes.liveChatIcon]: LiveChatIcon,
  [IconTypes.sendMessageIcon]: SendMessageIcon,
  [IconTypes.envelopeIcon]: EnvelopeIcon,
  [IconTypes.headphones]: HeadphonesIcon,
  [IconTypes.chartIcon]: ChartIcon,
  [IconTypes.telegramSocial]: TelegramSocialIcon,
  [IconTypes.xIcon]: XIcon,
  [IconTypes.instagramSocial]: InstagramSocialIcon,
  [IconTypes.linkedinSocial]: LinkedInIcon,
  [IconTypes.internetIcon]: InternetIcon,
  [IconTypes.bonusEmptyIcon]: BonusEmptyIcon,
  [IconTypes.bonusIcon]: BonusIcon,
  [IconTypes.rewardCashBonusIcon]: RewardCashBonusIcon,
  [IconTypes.rewardFreeTicketIcon]: RewardFreeTicketIcon,
  [IconTypes.rewardFreeBetIcon]: RewardFreeBetIcon,
  [IconTypes.rewardFirstDepositIcon]: RewardFirstDepositIcon,
  [IconTypes.rewardMerchIcon]: RewardMerchIcon,
  [IconTypes.rewardFreeSpinIcon]: RewardFreeSpinIcon,
  [IconTypes.rewardFreeSubscriptionsIcon]: RewardFreeSubscriptionsIcon,
  [IconTypes.rewardOtherIcon]: RewardOtherIcon,
  [IconTypes.folderSettingsIcon]: FolderSettingsIcon,
  [IconTypes.mediaImageIcon]: MediaImageIcon,
  [IconTypes.voiceIcon]: VoiceIcon,
  [IconTypes.gifFormatIcon]: GifFormatIcon,
  [IconTypes.videoCameraIcon]: VideoCameraIcon,
  [IconTypes.microphoneIcon]: MicrophoneIcon,
  [IconTypes.recordIcon]: RecordIcon,
  [IconTypes.subscriptionPlanIcon]: SubscriptionPlanIcon,
}

export interface SvgIconProps {
  width?: number;
  height?: number;
  color: IconColor;
}

export const SportIcon = [
  { id: 1, name: 'soccer', icon: '⚽' },
  { id: 2, name: 'basketball', icon: '🏀' },
  { id: 3, name: 'tennis', icon: '🎾' },
  { id: 4, name: 'hockey', icon: '🏑' },
  { id: 5, name: 'handball', icon: '🤾‍♂️' },
  { id: 6, name: 'volleyball', icon: '🏐' },
  { id: 7, name: 'american football', icon: '🏈' },
  { id: 8, name: 'baseball', icon: '⚾' },
  { id: 9, name: 'cricket', icon: '🏏' },
  { id: 10, name: 'rugby', icon: '🏉' },
  { id: 11, name: 'rugby league', icon: '🏉' },
  { id: 12, name: 'boxing', icon: '🥊' },
  { id: 13, name: 'esports', icon: '🏆' },
  { id: 14, name: 'MMA', icon: '' },
  { id: 15, name: 'table tennis', icon: '🏓' },
]
